// extracted by mini-css-extract-plugin
export var graphic = "WhatWeDo-module--graphic--anYSK";
export var svg = "WhatWeDo-module--svg--1aLH1";
export var labels = "WhatWeDo-module--labels--13Y1b";